import React, {useState, useEffect} from 'react';
import Image from "next/image";
import IMAGES from '@/public/assets/img';
import { SEODATA } from '@/config/seo_config';
import { useRouter } from 'next/router';
import 'rc-slider/assets/index.css';
import Link from 'next/link';
import loadable from '@loadable/component';
import Head from "next/head";
import { getMetadata } from "@/component/shared/getMetaData";
import { WEB_URL } from '@/config/endpoints';
import enIN from '@/locales/interestCal/enIN';
import enUS from '@/locales/interestCal/enUS';
import esMX from '@/locales/interestCal/esMX';
import { pushCleverTapEvent } from '@/component/shared/pushCleverTapEvent';


const Slider = loadable(() => import('rc-slider'))


const InterestCalculator = () => {

    const router = useRouter();
    const { locale } = router;
    const t = (locale === 'es-mx' && esMX) || (locale === 'en-us' && enUS) || (locale === 'en-in' && enIN);
    const metadata = getMetadata(t);

const [principal, setPrincipal] = useState('100000');
const [duration, setDuration] = useState('60');
//   const [interestCred, setInterestCred] = useState(0);
//   const [interestOther, setInterestOther] = useState(0);
  const [fACredlix, setFACredlix] = useState('90000');
  const [fAOther, setFAOther] = useState('80000');

  const [discountRateCredlix,setDiscountRateCredlix] = useState('9');
  const [discountAmountCred,setDiscountAmountCred] = useState('1350')
  
  const [discountAmountOther,setDiscountAmountOther] = useState('733.33')
  const [discountRateOther,setDiscountRateOther] = useState('5.5');
  const [facFeeOther,setFacFeeOther] = useState('1.2')
  const [facFeeOtherAmount,setFacFeeOtherAmount] = useState('1200')
  const [totalFeeOther,setTotalFeeOther] = useState('')
  const [totalFeeCred,setTotalFeeCred] = useState('')
  const [showInputDCOther, setShowInputDCOther] = useState(false)
  const [showEditDCOther, setShowEditDCOther] = useState(true)
  const [showInputFFOther, setShowInputFFOther] = useState(false)
  const [showEditFFOther, setShowEditFFOther] = useState(true)
  const [showInputCred, setShowInputCred] = useState(false)
  const [showEditCred, setShowEditCred] = useState(true)
  const [eventFired, setEventFired] = useState(false);
//   Mexico values

const [durationMexico, setDurationMexico] = useState('30');
const [discountRateCredlixMexico,setDiscountRateCredlixMexico] = useState('1.5');
const [discountAmountCredMexico,setDiscountAmountCredMexico] = useState('1350')

const [discountAmountOtherMexico,setDiscountAmountOtherMexico] = useState('1600')
const [discountRateOtherMexico,setDiscountRateOtherMexico] = useState('2.0');

const [totalFeeOtherMexico,setTotalFeeOtherMexico] = useState('')
const [totalFeeCredMexico,setTotalFeeCredMexico] = useState('')
  
useEffect(() => {
    if(locale != 'en-in'){
    setDiscountRateOtherMexico('2.0');
    setDiscountRateCredlixMexico('1.5');
} else if (locale === 'en-in') {  
         pushCleverTapEvent("Interest_Calculator_Visitor", {
                "PageName": 'Interest_Calculator',
        });
}

}, [])



  const marksPrincipal = {
    1000: '1k',
    250000: '250k',
    500000: '500k',
    750000: '750k',
    1000000: '1M',
  };
  const marksDuration = {
    30: '30',
    45: '45',
    60: '60',
    75: '75',
    90: '90',
    105: '105',
    120: '120',
  };

  
  const getPrincipalAmount=(value)=>{
    setPrincipal(value);
    fACredlixFunction(value)
    fAOtherFunction(value);
    let drCred = 0.9 * value;
     drCred = discountRateCredlix/100 * drCred
     drCred = drCred * duration/360
    setDiscountAmountCred(drCred.toFixed(2)) 
    let drOther = 0.8 * value;
    drOther = discountRateOther/100 * drOther
    drOther = drOther * duration/360
    setDiscountAmountOther(drOther.toFixed(2)) 
    let ffA = 0.012*value;
    setFacFeeOtherAmount(ffA.toFixed(2))
    totalFeeOtherFunction()
    totalFeeCredFunction()
    if (!eventFired) {
        pushCleverTapEvent("Interest_Calculator_Invoice_Amount_Changed", {
          'PageName': "Interest_Calculator"});
        setEventFired(true);
      }   
    // Mexico
    let drCredMexico = 0.9 * value;
    drCredMexico = discountRateCredlixMexico/100 * drCredMexico
   setDiscountAmountCredMexico(drCredMexico.toFixed(2)) 
   let drOtherMexico = 0.8 * value;
   drOtherMexico = discountRateOtherMexico/100 * drOtherMexico
   setDiscountAmountOtherMexico(drOtherMexico.toFixed(2)) 
  }
  const sliderHandler=(value)=>{
   
    setPrincipal(value)
    fACredlixFunction(value)
    fAOtherFunction(value);
    let drCred = 0.9 * value;
     drCred = discountRateCredlix/100 * drCred
     drCred = drCred * duration/360
    setDiscountAmountCred(drCred.toFixed(2)) 
    let drOther = 0.8 * value;
    drOther = discountRateOther/100 * drOther
    drOther = drOther * duration/360
    setDiscountAmountOther(drOther.toFixed(2))  
    let ffA = 0.012*value;
    // ffA = ffA*duration/360;
    setFacFeeOtherAmount(ffA.toFixed(2))
    totalFeeOtherFunction()
    totalFeeCredFunction()

    // Mexico
    let drCredMexico = 0.9 * value;
     drCredMexico = discountRateCredlixMexico/100 * drCredMexico
    setDiscountAmountCredMexico(drCredMexico.toFixed(2)) 
    let drOtherMexico = 0.8 * value;
    drOtherMexico = discountRateOtherMexico/100 * drOtherMexico
    setDiscountAmountOtherMexico(drOtherMexico.toFixed(2))  
    totalFeeOtherFunctionMexico()
    totalFeeCredFunctionMexico()
  }
 
  const getDuration=(value)=>{
    setDuration(value);
    fACredlixFunction(principal)
    fAOtherFunction(principal)
    let drCred = 0.9 * principal;
    drCred = discountRateCredlix/100 * drCred
    drCred = drCred * value/360
   setDiscountAmountCred(drCred.toFixed(2)) 
   let drOther = 0.8 * principal;
    drOther = discountRateOther/100 * drOther
    drOther = drOther * value/360
    setDiscountAmountOther(drOther.toFixed(2)) 
    let ffA = 0.012*principal;
    const tfO = parseFloat(ffA) + parseFloat(drOther)
    setTotalFeeOther(tfO.toFixed(2)) 
    const tf1 = parseFloat(drCred)
    setTotalFeeCred(tf1.toFixed(2)) 
    if (!eventFired) {
        pushCleverTapEvent("Interest_Calculator_Tenure_Changed", {
          'PageName': "Interest_Calculator"});
        setEventFired(true);
      }  
    // Mexico
    setDurationMexico(value);
    let drCredMexico = 0.9 * principal;
    drCredMexico = discountRateCredlixMexico/100 * drCredMexico * value/30
    // drCredMexico = drCredMexico * value/30
   setDiscountAmountCredMexico(drCredMexico.toFixed(2)) 
//    console.log('drCredMexico',drCredMexico)
   let drOtherMexico = 0.8 * principal;
    drOtherMexico = discountRateOtherMexico/100 * drOtherMexico * value/30
    // drOtherMexico = drOtherMexico * value/30
    setDiscountAmountOtherMexico(drOtherMexico.toFixed(2)) 
    setTotalFeeOther(drOtherMexico.toFixed(2)) 
    setTotalFeeCred(drCredMexico.toFixed(2)) 

  }
  const getSlideDuration=(value)=>{
    setDuration(value);
    fACredlixFunction(principal)
    fAOtherFunction(principal)
    let drCred = 0.9 * principal;
    drCred = discountRateCredlix/100 * drCred
    drCred = drCred * value/360
   setDiscountAmountCred(drCred.toFixed(2)) 
   let drOther = 0.8 * principal;
    drOther = discountRateOther/100 * drOther
    drOther = drOther * value/360
    setDiscountAmountOther(drOther.toFixed(2)) 
    let ffA = 0.012*principal;
    const tfO = parseFloat(ffA) + parseFloat(drOther)
    setTotalFeeOther(tfO.toFixed(2)) 
    const tf1 = parseFloat(drCred)
    setTotalFeeCred(tf1.toFixed(2)) 

    // Mexico
    setDurationMexico(value);
    let drCredMexico = 0.9 * principal;
    drCredMexico = discountRateCredlixMexico/100 * drCredMexico * value/30
   setDiscountAmountCredMexico(drCredMexico.toFixed(2)) 
   setTotalFeeCredMexico(drCredMexico.toFixed(2)) 

   let drOtherMexico = 0.8 * principal;
    drOtherMexico = discountRateOtherMexico/100 * drOtherMexico * value/30
    setDiscountAmountOtherMexico(drOtherMexico.toFixed(2)) 
    setTotalFeeOtherMexico(drOtherMexico.toFixed(2)) 
    // const tf1 = parseFloat(drCred)
    
  }
 
  const fACredlixFunction=(principal)=>{
     setFACredlix((90/100 * principal).toFixed(2))
    
  }
  const fAOtherFunction=(principal)=>{
    setFAOther((80/100 * principal).toFixed(2))
    
    // return  80/100 * principal
 }
 const DCRateCred=(rate)=>{
    setDiscountRateCredlix(rate)
    setDiscountAmountCred(((rate/100 * fACredlix)*duration/360).toFixed(2))
 }
 const DCRateOther=(rate)=>{
  setDiscountRateOther(rate)
  setDiscountAmountOther(((rate/100 * fAOther)*duration/360).toFixed(2))
 }
//  Mexico
const DCRateCredMexico=(rate)=>{
    setDiscountRateCredlixMexico(rate)
    setDiscountAmountCredMexico((0.9 * principal * (rate/100)*durationMexico/30).toFixed(2))
 }
 const DCRateOtherMexico=(rate)=>{
  setDiscountRateOtherMexico(rate)
  setDiscountAmountOtherMexico((0.8 * principal * (rate/100)*durationMexico/30).toFixed(2))
 }

 const facFeeOtherFunction=(fee)=>{
  setFacFeeOther(fee)
  setFacFeeOtherAmount((fee/100 * principal).toFixed(2))
 }
 const totalFeeOtherFunction=()=>{
    const tfO = parseFloat(facFeeOtherAmount) + parseFloat(discountAmountOther)
    setTotalFeeOther(tfO.toFixed(2)) 

 }
 const totalFeeCredFunction=()=>{
    const tfO = parseFloat(discountAmountCred)
    setTotalFeeCred(tfO.toFixed(2)) 
 }

 const totalFeeOtherFunctionMexico=()=>{
    const tfO = parseFloat(discountAmountOtherMexico)
    setTotalFeeOtherMexico(tfO.toFixed(2)) 
 }
 const totalFeeCredFunctionMexico=()=>{
    const tfO = parseFloat(discountAmountCredMexico)
    setTotalFeeCredMexico(tfO.toFixed(2)) 
 }

 const showInputFunction=(orgType)=>{
    if(orgType === 'DC'){
        setShowInputDCOther(true);
        setShowEditDCOther(false);
    }
    if(orgType === 'FF'){
        setShowInputFFOther(true)
        setShowEditFFOther(false)
    }
    if(orgType === 'Cred'){
        setShowInputCred(true);
        setShowEditCred(false);
    }
 }
 const showInputFunctionForES=(orgType)=>{
    if(orgType === 'DC'){
        setShowInputDCOther(true);
        setShowEditDCOther(false);
        window.gtag('event', 'Edit ROI', {
            'event_category': 'editROI',
            'event_label': 'editROI'
          });
    }
    if(orgType === 'FF'){
        setShowInputFFOther(true)
        setShowEditFFOther(false)
    }
    if(orgType === 'Cred'){
        setShowInputCred(true);
        setShowEditCred(false);
        window.gtag('event', 'Edit ROI', {
            'event_category': 'editROI',
            'event_label': 'editROI'
          });
    }
 }
 const addDCOther=(orgType)=>{
    DCRateOther(discountRateOther)
    DCRateOtherMexico(discountRateOtherMexico)
    if(orgType === 'DC'){
        setShowEditDCOther(true)
        setShowInputDCOther(false)
    }
    if(orgType === 'FF'){
        setShowEditFFOther(true)
        setShowInputFFOther(false)
    }
    if(orgType === 'Cred'){
        setShowInputCred(false);
        setShowEditCred(true);
    }
 }
 const closeEdit=(orgType)=>{
    if(orgType === 'DC'){
        setShowEditDCOther(true)
        setShowInputDCOther(false)
        setDiscountRateOther(4.5)
        setDiscountRateOtherMexico(2.0)
    }
    if(orgType === 'FF'){
        setShowEditFFOther(true)
        setShowInputFFOther(false)
        setFacFeeOther(1.2)
    }  
    if(orgType === 'Cred'){
        setShowInputCred(false);
        setShowEditCred(true);
        setDiscountRateCredlix(9)
        setDiscountRateCredlixMexico(1.5)
    } 
    
 }
 useEffect(() => {
    
    totalFeeOtherFunction()
    totalFeeCredFunction()
    totalFeeOtherFunctionMexico()
    totalFeeCredFunctionMexico()
   
  }, [principal,fACredlix,totalFeeOtherFunction,
        totalFeeCredFunction,
        totalFeeOtherFunctionMexico,
        totalFeeCredFunctionMexico]);

    return(
        <main>
                
           <Head>
              <title>{metadata.title}</title>
              <meta name="description" content={metadata.description} />
              <meta name="keywords" content={metadata.keywords} />
              <link rel="icon" href={metadata.icon} />
              <meta property="og:title" content={metadata.openGraph.title} />
              <meta property="og:description" content={metadata.openGraph.description} />
              <meta property="og:image" content={metadata.openGraph.images} />
              <meta property="og:url" content={metadata.openGraph.url} />
              <link rel="canonical" href={metadata.alternates.canonical} />
              {locale === 'en-in' &&
              <script
                type="application/ld+json"
                dangerouslySetInnerHTML={{
                __html: JSON.stringify({
                    "@context": "https://schema.org",
                    "@type": "WebApplication",
                    "name": "Interest Rate Calculator for Export Credit",
                    "url": WEB_URL+`/interest-calculator`,
                    "browserRequirements": "JavaScript-enabled browser",
                    "applicationCategory": "Business",
                    "operatingSystem": "All",
                    "description": "Easily calculate interest rates for export credit using Credlix's free online tool for Indian exporters.",
                    "inLanguage": "en",
                    "publisher": {
                    "@type": "Organization",
                    "name": "Credlix"
                    },
                    "offers": {
                    "@type": "Offer",
                    "price": "0",
                    "priceCurrency": "INR"
                    }
                })
                }}
            />}
              
          </Head>
        {t.CalcIndia  &&
         <section className="py-20 relative bg-cal sm:py-24">
                <div className="container px-3 h-full xm:px-2 ">
                    <div className="flex flex-wrap sm:mt-[40px] mt-[80px]">
                        <div className="w-[42%] md:w-full sm:w-full relative z-10">
                            <h1 className="text-brand text-xl">Interest Rate Calculator <br className="sm:hidden md:hidden xm:hidden"/> for Export Credit</h1>
                            <ul className="pl-[0px] md:flex-row md:flex">
                                <li className="flex items-center py-2 md:pr-1">
                                    <span className="mr-[8px]"><svg xmlns="https://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16"><path d="M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM11.0026 16L18.0737 8.92893L16.6595 7.51472L11.0026 13.1716L8.17421 10.3431L6.75999 11.7574L11.0026 16Z" fill="rgba(42,158,33,1)"></path></svg></span> 
                                    <p className="text-base text-brand"><strong>Zero</strong> Factoring charge</p>
                                </li>
                                <li className="flex items-center pb-2 md:py-2 md:px-1">
                                    <span className="mr-[8px]"><svg xmlns="https://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16"><path d="M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM11.0026 16L18.0737 8.92893L16.6595 7.51472L11.0026 13.1716L8.17421 10.3431L6.75999 11.7574L11.0026 16Z" fill="rgba(42,158,33,1)"></path></svg></span> 
                                    <p className="text-base text-brand"><strong>Up to 90% </strong>disbursement</p>
                                </li>
                                <li className="flex items-center pb-2 md:py-2 md:px-1">
                                    <span className="mr-[8px]"><svg xmlns="https://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16"><path d="M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM11.0026 16L18.0737 8.92893L16.6595 7.51472L11.0026 13.1716L8.17421 10.3431L6.75999 11.7574L11.0026 16Z" fill="rgba(42,158,33,1)"></path></svg></span> 
                                    <p className="text-base text-brand"><strong>lowest</strong> interest fee</p>
                                </li>
                            </ul>
                            <h2 className="text-brand text-base2 mt-6 font-medium md:mt-4">Calculate Per Invoice Cost</h2>
                            <div className="flex items-center justify-between sm:w-full w-[340px] mt-3 mb-2">
                                <h4 className="text-brand text-base font-semibold">Invoice amount (In $)</h4>
                                <div className=' w-[130px] items-center flex text-base border border-[#1479FC] bg-white pl-[10px] text-[#1479FC] font-medium '>
                                    <span>$ </span>
                                <input 
                                type="text" value={principal} onChange={(e) => getPrincipalAmount(e.target.value)}
                                className="text-[#1479FC] w-[100%] font-medium outline-none text-base pr-[10px] pl-[5px] h-[32px]"
                                /></div>
                                 
                            </div>
                            <div className="flex items-center justify-between sm:w-full w-[340px] mt-3 mb-2 rangeSlider">
                            <Slider min={1000} max={1000000} step={250} onChange={sliderHandler} marks={marksPrincipal} value={principal} />
                            </div>
                            
                            <div className="flex items-center justify-between w-[340px] mt-6">
                                <h4 className="text-brand text-base font-semibold">Tenor (In days)</h4>
                                <div className=' w-[130px] items-center justify-center flex text-base border border-[#1479FC] bg-white pr-[10px] text-[#1479FC] font-medium '>
                                    
                                <input 
                                value={duration} onChange={(e) => getDuration(e.target.value)}
                                className="text-[#1479FC] w-[33px] min-w-0  text-center font-medium outline-none text-base h-[32px]"
                                /><span>days </span></div>
                                
                                
                            </div>
                            <div className="flex items-center justify-between sm:w-full w-[340px] mt-3 mb-2 rangeSlider">
                                <Slider min={30} max={120} step={15} onChange={getSlideDuration} marks={marksDuration} value={duration} />
                            </div>
                        </div>
                        <div className="w-[57%] md:w-full sm:w-full relative z-10 md:mt-6 sm:mt-6">
                            <h2 className="text-brand text-lg mb-3 lg:w-[80%] md:w-[80%] mx-auto text-center">Fastest growing and one of the largest Export factoring companies in India.</h2>
                            <div className="grid grid-cols-2 sm:grid-cols-1 gap-1">
                            <div className="border border-[#CCCCCC] bg-white shadow-box-border rounded-[10px] pt-[24px] pb-3 sm:mt-5 min-h-[450px]">
                                    <div className="px-3">
                                     <h2 className="text-brand text-lg">Competition</h2>
                                    </div>
                                     <ul className="pl-[0px] pt-2">
                                        <li className="relative">
                                            <p className="text-base text-brand px-3">Invoice Amount</p>
                                            <span className="text-base text-brand font-semibold px-3 before:content-'' before:border-b before:w-full before:h-1 before:absolute before:left-0 before:bottom-[-7px] before:border-dashed before:border-[#CCCCCC]">{principal}</span>
                                        </li>
                                        <li className="relative">
                                            <p className="text-base text-brand px-3 pt-2">Funding Amount (80% funding)</p>
                                            <span className="text-base text-brand font-semibold px-3 before:content-'' before:border-b before:w-full before:h-1 before:absolute before:left-0 before:bottom-[-7px] before:border-dashed before:border-[#CCCCCC]">{fAOther}</span>
                                        </li>
                                        <li className="relative">
                                             <p className="text-base text-brand px-3 pt-2">Tenor</p>
                                            <span className="text-base text-brand font-semibold px-3 before:content-'' before:border-b before:w-full before:h-1 before:absolute before:left-0 before:bottom-[-7px] before:border-dashed before:border-[#CCCCCC]">{duration} days</span>
                                        </li>
                                        <li className="relative min-h-[100px]">
                                            <div className="px-3 flex items-center pt-2">
                                             <p className="text-base text-brand">Discounting rate @ <span className='w-[50px] inline-block'>{discountRateOther}%</span></p>
                                             {showEditDCOther && 
                                              <button className="text-[#1479FC] text-sm decoration-dashed decoration-[#1479FC]" onClick={()=>showInputFunction('DC')}>Edit</button>
                                             }
                                              {showInputDCOther && 
                                              <div className="text-[#1479FC] text-base border border-[#1479FC] bg-white flex items-center px-[6px] h-[25px] ml-[10px]">
                                             <input
                                             type='text' maxLength={5}
                                             className="text-[#1479FC] outline-none w-[45px] h-[23px] text-sm"
                                             value={discountRateOther} placeholder='4.5' onChange={(e)=>DCRateOther(e.target.value)}
                                             />
                                             
                                             
                                                <button className="align-middle mx-[2px]" onClick={()=>addDCOther('DC')}>
                                                <svg xmlns="https://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16">
                                                    <path
                                                    d="M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM11.0026 16L18.0737 8.92893L16.6595 7.51472L11.0026 13.1716L8.17421 10.3431L6.75999 11.7574L11.0026 16Z"
                                                    fill="rgba(42,158,33,1)"
                                                    ></path>
                                                </svg>
                                                </button>
                                                <button className="align-middle mx-[2px]" onClick={()=>closeEdit('DC')}>
                                                <svg xmlns="https://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16">
                                                    <path
                                                    d="M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 10.5858L9.17157 7.75736L7.75736 9.17157L10.5858 12L7.75736 14.8284L9.17157 16.2426L12 13.4142L14.8284 16.2426L16.2426 14.8284L13.4142 12L16.2426 9.17157L14.8284 7.75736L12 10.5858Z"
                                                    fill="rgba(0,0,0,1)"
                                                    ></path>
                                                </svg>
                                                </button>

                                             </div>
                                            }
                                            </div>
                                            <span className='text-xs px-3 '>(Applicable for the <strong>Funding Amount</strong> i.e, 80%)</span>
                                            <div className="text-base text-brand font-semibold px-3 before:content-'' before:border-b before:w-full before:h-1 before:absolute before:left-0 before:bottom-[-7px] before:border-dashed before:border-[#CCCCCC]">{discountAmountOther}</div>
                                        </li>
                                        <li className="relative min-h-[110px]">
                                        <div className="px-3 flex items-center pt-2">
                                             <p className="text-base text-brand">Factoring fee @ <span className='w-[50px] inline-block'>{facFeeOther}%</span></p>
                                             {showEditFFOther && 
                                              <button className="text-[#1479FC] text-sm decoration-dashed decoration-[#1479FC]" onClick={()=>showInputFunction('FF')}>Edit</button>
                                             }
                                             {showInputFFOther && 
                                              <div className="text-[#1479FC] text-base border border-[#1479FC] bg-white flex items-center px-[6px] h-[25px] ml-[10px]">
                                                <input
                                                type='text' maxLength={5}
                                                className="text-[#1479FC] outline-none w-[45px] h-[23px] text-sm"
                                                value={facFeeOther} placeholder='4.5' onChange={(e)=>facFeeOtherFunction(e.target.value)}
                                                />
                                                <button className="align-middle mx-[2px]" onClick={()=>addDCOther('FF')}>
                                                <svg xmlns="https://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16">
                                                    <path
                                                    d="M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM11.0026 16L18.0737 8.92893L16.6595 7.51472L11.0026 13.1716L8.17421 10.3431L6.75999 11.7574L11.0026 16Z"
                                                    fill="rgba(42,158,33,1)"
                                                    ></path>
                                                </svg>
                                                </button>
                                                <button className="align-middle mx-[2px]" onClick={()=>closeEdit('FF')}>
                                                <svg xmlns="https://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16">
                                                    <path
                                                    d="M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 10.5858L9.17157 7.75736L7.75736 9.17157L10.5858 12L7.75736 14.8284L9.17157 16.2426L12 13.4142L14.8284 16.2426L16.2426 14.8284L13.4142 12L16.2426 9.17157L14.8284 7.75736L12 10.5858Z"
                                                    fill="rgba(0,0,0,1)"
                                                    ></path>
                                                </svg>
                                                </button>
                                             </div>
                                            }
                                            </div>
                                            <span className='text-xs px-3 block'>(Applied on the entire <strong>Invoice Amount</strong>, thus effective p.a pricing will be higher !)</span>
                                            <div className="text-base text-brand font-semibold px-3 before:content-'' before:border-b before:w-full before:h-1 before:absolute before:left-0 before:bottom-[-7px] before:border-dashed before:border-[#CCCCCC]">{facFeeOtherAmount}</div>
                                        </li>
                                        
                                        <li className="relative flex items-center px-3 pt-2 justify-center">
                                             <p className="text-base text-brand">Total Fees</p>
                                            <span className="text-base text-brand font-semibold pl-[5px]">$ {totalFeeOther}</span>
                                        </li>
                                     </ul>
                                </div>
                                <div className="border border-[#E3A200] bg-[#FFF7E3] shadow-calc-border rounded-[10px] pt-5 pb-3 mr-2 sm:mr-0 min-h-[450px]">
                                    <div className="px-3">
                                     <Image loading='lazy' className="w-[75px] h-auto" src={IMAGES.calcInterest.logoCredlix} alt="logo"/>
                                    </div>
                                     <ul className="pl-[0px] pt-2">
                                        <li className="relative">
                                            <p className="text-base text-brand px-3">Invoice Amount</p>
                                            <span className="text-base text-brand font-semibold px-3 before:content-'' before:border-b before:w-full before:h-1 before:absolute before:left-0 before:bottom-[-7px] before:border-dashed before:border-[#FBE9BF]">{principal}</span>
                                        </li>
                                        <li className="relative">
                                            <p className="text-base text-brand px-3 pt-2">Funding Amount (90% funding)</p>
                                            <span className="text-base text-brand font-semibold px-3 before:content-'' before:border-b before:w-full before:h-1 before:absolute before:left-0 before:bottom-[-7px] before:border-dashed before:border-[#FBE9BF]">{fACredlix}</span>
                                        </li>
                                        <li className="relative">
                                             <p className="text-base text-brand px-3 pt-2">Tenor</p>
                                            <span className="text-base text-brand font-semibold px-3 before:content-'' before:border-b before:w-full before:h-1 before:absolute before:left-0 before:bottom-[-7px] before:border-dashed before:border-[#FBE9BF]">{duration} days</span>
                                        </li>
                                        <li className="relative min-h-[100px]">
                                            <div className="px-3 flex items-center pt-2">
                                             <p className="text-base text-brand">Discounting rate @ <span className='w-[50px] inline-block'>{discountRateCredlix}%</span></p>
                                             {showEditCred && 
                                              <button className="text-[#1479FC] text-sm decoration-dashed decoration-[#1479FC]" onClick={()=>showInputFunction('Cred')}>Edit</button>
                                             }
                                             {showInputCred && 
                                             <div className="text-[#1479FC] text-base border border-[#1479FC] bg-white flex items-center px-[6px] h-[25px] ml-[10px]">
                                             <input type='text' maxLength={5}
                                                className="text-[#1479FC] outline-none w-[45px] h-[23px] text-sm"
                                                  value={discountRateCredlix} placeholder='9' onChange={(e) => DCRateCred(e.target.value)}
                                                />
                                                <button className="align-middle mx-[2px]" onClick={()=>addDCOther('Cred')}>
                                                <svg xmlns="https://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16">
                                                    <path
                                                    d="M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM11.0026 16L18.0737 8.92893L16.6595 7.51472L11.0026 13.1716L8.17421 10.3431L6.75999 11.7574L11.0026 16Z"
                                                    fill="rgba(42,158,33,1)"
                                                    ></path>
                                                </svg>
                                                </button>
                                                <button className="align-middle mx-[2px]" onClick={()=>closeEdit('Cred')}>
                                                <svg xmlns="https://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16">
                                                    <path
                                                    d="M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 10.5858L9.17157 7.75736L7.75736 9.17157L10.5858 12L7.75736 14.8284L9.17157 16.2426L12 13.4142L14.8284 16.2426L16.2426 14.8284L13.4142 12L16.2426 9.17157L14.8284 7.75736L12 10.5858Z"
                                                    fill="rgba(0,0,0,1)"
                                                    ></path>
                                                </svg>
                                                </button>
                                             </div>
                                            }
                                            </div>
                                            <span className='text-xs px-3 block'>(Applied on the actual <strong>Funding Amount</strong> i.e, 90%)</span>
                                            <span className="text-base text-brand font-semibold px-3 before:content-'' before:border-b before:w-full before:h-1 before:absolute before:left-0 before:bottom-[-7px] before:border-dashed before:border-[#FBE9BF]">{discountAmountCred}</span>
                                        </li>
                                        <li className="relative min-h-[110px]">
                                             <p className="text-base text-brand px-3 pt-2">Factoring fee @ <strong>Nil</strong></p>
                                             <span className='text-xs px-3 block'>(We do not charge any factoring fees! )</span>
                                            <span className="text-base text-brand font-semibold px-3 before:content-'' before:border-b before:w-full before:h-1 before:absolute before:left-0 before:bottom-[-7px] before:border-dashed before:border-[#FBE9BF]">0</span>
                                            
                                        </li>
                                       
                                        <li className="relative flex items-center px-3 pt-2 justify-center">
                                             <p className="text-base text-brand">Total Fees</p>
                                            <span className="text-base text-[#299E22] font-semibold pl-[5px]">$ {totalFeeCred}</span>
                                        </li>
                                     </ul>
                                </div>
                                
                            </div>
                            <div className="mt-3 flex items-center justify-between sm:flex-col pr-2">
                                <p className="text-base text-brand font-medium">Our Promise: In case you are getting a better price,
 <br className="sm:hidden"/> then we will match that price.</p>
                                <Link href="https://app.credlix.com/nuphi/#/signup/exporter/verify" target="_blank" rel="noopener noreferrer" onClick={()=>pushCleverTapEvent('Interest_Calculator_Start_Now',{"PageName": 'Interest_Calculator', 'userProperties': 'lead_score'})} className="text-white py-1 px-3 rounded-lg flex items-center sm:mt-3 bg-gradient-to-r from-[#022B5C] to-[#0363C4] shadow-md transition-all duration-300 ease-in-out hover:from-[#0363C4] hover:to-[#022B5C]">Start Now
                                  <span className="mr-[5px] align-middle"><svg xmlns="https://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path d="M12.1717 12.0005L9.34326 9.17203L10.7575 7.75781L15.0001 12.0005L10.7575 16.2431L9.34326 14.8289L12.1717 12.0005Z" fill="rgba(255,255,255,1)"></path></svg></span>
                                </Link>
                            </div>
                        </div>   
                </div>
            </div>
        </section>
        
        }
         {!t.CalcIndia &&
     
         <section className="py-20 relative bg-cal">
                <div className="container px-3 h-full xm:px-2 ">
                    <div className="flex flex-wrap sm:mt-[30px] mt-[50px]">
                        <div className="w-[40%] md:w-full sm:w-full relative z-10">
                            <h1 className="text-brand text-base2" dangerouslySetInnerHTML={{__html:t.Calc.leftHeading}} />
                            <ul className="pl-[0px] pt-2 md:flex-row md:flex">
                                {t.Calc.whyCalculate.map((item,i)=>(
                                    <li key={i} className="flex items-center pb-2 md:pr-1">
                                    <span className="mr-[8px]"><svg xmlns="https://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16"><path d="M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM11.0026 16L18.0737 8.92893L16.6595 7.51472L11.0026 13.1716L8.17421 10.3431L6.75999 11.7574L11.0026 16Z" fill="rgba(42,158,33,1)"></path></svg></span> 
                                    <p className="text-base text-brand" dangerouslySetInnerHTML={{__html:item}} />
                                </li>
                                ))}
                                
                            </ul>
                            <h2 className="text-brand text-base2 mt-6 font-medium md:mt-4">{t.Calc.heading2}</h2>
                            <div className="flex items-center justify-between sm:w-full w-[340px] mt-3 mb-2">
                                <h4 className="text-brand text-base font-semibold">{t.Calc.principalAmt}</h4>
                                <div className=' w-[130px] items-center flex text-base border border-[#1479FC] bg-white pl-[10px] text-[#1479FC] font-medium '>
                                    <span>$ </span>
                                <input type="text" value={principal} onChange={(e) => getPrincipalAmount(e.target.value)}
                                className="text-[#1479FC] w-[100%] font-medium outline-none text-base pr-[10px] pl-[5px] h-[32px]"
                                /></div>
                                 
                            </div>
                            <div className="flex items-center justify-between sm:w-full w-[340px] mt-3 mb-2 rangeSlider">
                            <Slider min={1000} max={1000000} step={250} onChange={sliderHandler} marks={marksPrincipal} value={principal} />
                            </div>
                            
                            <div className="flex items-center justify-between w-[340px] mt-6">
                                <h4 className="text-brand text-base font-semibold">{t.Calc.tenor}</h4>
                                <div className=' w-[130px] items-center justify-center flex text-base border border-[#1479FC] bg-white pr-[10px] text-[#1479FC] font-medium '>
                                    
                                <input 
                                value={durationMexico} onChange={(e) => getDuration(e.target.value)}
                                className="text-[#1479FC] w-[33px] min-w-0  text-center font-medium outline-none text-base h-[32px]"
                                /><span>{t.Calc.days} </span></div>
                                
                                
                            </div>
                            <div className="flex items-center justify-between sm:w-full w-[340px] mt-3 mb-2 rangeSlider">
                                <Slider min={30} max={120} step={15} onChange={getSlideDuration} marks={marksDuration} value={durationMexico} />
                            </div>
                        </div>
                        <div className="w-[60%] md:w-full sm:w-full relative z-10 md:mt-6 sm:mt-6">
                            <h2 className="text-brand text-lg mb-3 lg:w-[80%] md:w-[80%] mx-auto text-center">{t.Calc.rightHeading}</h2>
                            <div className="grid grid-cols-2 sm:grid-cols-1 gap-1">
                            <div className="border border-[#CCCCCC] bg-white shadow-box-border rounded-[10px] pt-[24px] pb-3 sm:mt-5 min-h-[430px]">
                                    <div className="px-3">
                                     <h2 className="text-brand text-base2">{t.Calc.competitionHead}</h2>
                                    </div>
                                     <ul className="pl-[0px] pt-2">
                                        <li className="relative">
                                            <p className="text-base text-brand px-3">{t.Calc.totAmt}</p>
                                            <span className="text-base text-brand font-semibold px-3 before:content-'' before:border-b before:w-full before:h-1 before:absolute before:left-0 before:bottom-[-7px] before:border-dashed before:border-[#CCCCCC]">{principal}</span>
                                        </li>
                                        <li className="relative">
                                            <p className="text-base text-brand px-3 pt-2">{t.Calc.fundAmt}</p>
                                            <span className="text-base text-brand font-semibold px-3 before:content-'' before:border-b before:w-full before:h-1 before:absolute before:left-0 before:bottom-[-7px] before:border-dashed before:border-[#CCCCCC]">{fAOther}</span>
                                        </li>
                                        <li className="relative">
                                             <p className="text-base text-brand px-3 pt-2">Tenor</p>
                                            <span className="text-base text-brand font-semibold px-3 before:content-'' before:border-b before:w-full before:h-1 before:absolute before:left-0 before:bottom-[-7px] before:border-dashed before:border-[#CCCCCC]">{durationMexico} {t.Calc.days}</span>
                                        </li>
                                        <li className="relative min-h-[138px]">
                                            <div className="px-3 flex items-center pt-2">
                                             <p className="text-base text-brand">{t.Calc.factorText} <span className='w-[100px] inline-block'>{discountRateOtherMexico}% pm</span></p>
                                             {showEditDCOther && 
                                              <button className="text-[#1479FC] text-sm decoration-dashed decoration-[#1479FC]" onClick={()=>showInputFunctionForES('DC')}>{t.Calc.edit}</button>
                                             }
                                              {showInputDCOther && 
                                              <div className="text-[#1479FC] text-base border border-[#1479FC] bg-white flex items-center px-[6px] h-[25px] ml-[10px]">
                                             <input
                                             type='text' maxLength={5}
                                             className="text-[#1479FC] outline-none w-[45px] h-[23px] text-sm"
                                             value={discountRateOtherMexico} placeholder='2.0' onChange={(e)=>DCRateOtherMexico(e.target.value)}
                                             />
                                             
                                             
                                                <button className="align-middle mx-[2px]" onClick={()=>addDCOther('DC')}>
                                                <svg xmlns="https://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16">
                                                    <path
                                                    d="M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM11.0026 16L18.0737 8.92893L16.6595 7.51472L11.0026 13.1716L8.17421 10.3431L6.75999 11.7574L11.0026 16Z"
                                                    fill="rgba(42,158,33,1)"
                                                    ></path>
                                                </svg>
                                                </button>
                                                <button className="align-middle mx-[2px]" onClick={()=>closeEdit('DC')}>
                                                <svg xmlns="https://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16">
                                                    <path
                                                    d="M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 10.5858L9.17157 7.75736L7.75736 9.17157L10.5858 12L7.75736 14.8284L9.17157 16.2426L12 13.4142L14.8284 16.2426L16.2426 14.8284L13.4142 12L16.2426 9.17157L14.8284 7.75736L12 10.5858Z"
                                                    fill="rgba(0,0,0,1)"
                                                    ></path>
                                                </svg>
                                                </button>

                                             </div>
                                            }
                                            </div>
                                            <p className='text-xs px-3'>{t.Calc.applicable}</p>
                                            <div className="text-base text-brand font-semibold px-3 before:content-'' before:border-b before:w-full before:h-1 before:absolute before:left-0 before:bottom-[-7px] before:border-dashed before:border-[#CCCCCC]">{discountAmountOtherMexico}</div>
                                        </li>
                                        
                                        
                                        <li className="relative flex items-center px-3 pt-2 justify-center">
                                             <p className="text-base text-brand">{t.Calc.totalText}</p>
                                            <span className="text-base text-brand font-semibold pl-[5px]">$ {totalFeeOtherMexico}</span>
                                        </li>
                                     </ul>
                                </div>
                                <div className="border border-[#E3A200] bg-[#FFF7E3] shadow-calc-border rounded-[10px] pt-5 pb-3 mr-2  sm:mr-0 min-h-[430px]">
                                    <div className="px-3">
                                     <Image loading='lazy' className="w-[75px] h-auto" src={IMAGES.calcInterest.logoCredlix} alt="logo"/>
                                    </div>
                                     <ul className="pl-[0px] pt-2">
                                        <li className="relative">
                                            <p className="text-base text-brand px-3">{t.Calc.principalAmt}</p>
                                            <span className="text-base text-brand font-semibold px-3 before:content-'' before:border-b before:w-full before:h-1 before:absolute before:left-0 before:bottom-[-7px] before:border-dashed before:border-[#FBE9BF]">{principal}</span>
                                        </li>
                                        <li className="relative">
                                            <p className="text-base text-brand px-3 pt-2">{t.Calc.fundAmtCredlix}</p>
                                            <span className="text-base text-brand font-semibold px-3 before:content-'' before:border-b before:w-full before:h-1 before:absolute before:left-0 before:bottom-[-7px] before:border-dashed before:border-[#FBE9BF]">{fACredlix}</span>
                                        </li>
                                        <li className="relative">
                                             <p className="text-base text-brand px-3 pt-2">Tenor</p>
                                            <span className="text-base text-brand font-semibold px-3 before:content-'' before:border-b before:w-full before:h-1 before:absolute before:left-0 before:bottom-[-7px] before:border-dashed before:border-[#FBE9BF]">{durationMexico} {t.Calc.days}</span>
                                        </li>
                                        <li className="relative min-h-[115px]">
                                            <div className="px-3 flex items-center pt-2">
                                             <p className="text-base text-brand">{t.Calc.factorText} <span className='w-[100px] inline-block'>{discountRateCredlixMexico}%</span></p>
                                             {showEditCred && 
                                              <button className="text-[#1479FC] text-sm decoration-dashed decoration-[#1479FC]" onClick={()=>showInputFunctionForES('Cred')}>{t.Calc.edit}</button>
                                             }
                                             {showInputCred && 
                                             <div className="text-[#1479FC] text-base border border-[#1479FC] bg-white flex items-center px-[6px] h-[25px] ml-[10px]">
                                             <input type='text' maxLength={5}
                                                className="text-[#1479FC] outline-none w-[45px] h-[23px] text-sm"
                                                  value={discountRateCredlixMexico} placeholder='1.5' onChange={(e) => DCRateCredMexico(e.target.value)}
                                                />
                                                <button className="align-middle mx-[2px]" onClick={()=>addDCOther('Cred')}>
                                                <svg xmlns="https://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16">
                                                    <path
                                                    d="M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM11.0026 16L18.0737 8.92893L16.6595 7.51472L11.0026 13.1716L8.17421 10.3431L6.75999 11.7574L11.0026 16Z"
                                                    fill="rgba(42,158,33,1)"
                                                    ></path>
                                                </svg>
                                                </button>
                                                <button className="align-middle mx-[2px]" onClick={()=>closeEdit('Cred')}>
                                                <svg xmlns="https://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16">
                                                    <path
                                                    d="M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 10.5858L9.17157 7.75736L7.75736 9.17157L10.5858 12L7.75736 14.8284L9.17157 16.2426L12 13.4142L14.8284 16.2426L16.2426 14.8284L13.4142 12L16.2426 9.17157L14.8284 7.75736L12 10.5858Z"
                                                    fill="rgba(0,0,0,1)"
                                                    ></path>
                                                </svg>
                                                </button>
                                             </div>
                                            }
                                            </div>
                                            <span className='text-xs px-3 block'>{t.Calc.applicableCred}</span>
                                            <span className="text-base text-brand font-semibold px-3 before:content-'' before:border-b before:w-full before:h-1 before:absolute before:left-0 before:bottom-[-7px] before:border-dashed before:border-[#FBE9BF]">{discountAmountCredMexico}</span>
                                        </li>
                                        {/* <li className="relative min-h-[110px]">
                                             <p className="text-base text-brand px-3 pt-2">Factoring fee @ <strong>Nil</strong></p>
                                             <span className='text-xs px-3 block'>(We do not charge any factoring fees! )</span>
                                            <span className="text-base text-brand font-semibold px-3 before:content-'' before:border-b before:w-full before:h-1 before:absolute before:left-0 before:bottom-[-7px] before:border-dashed before:border-[#FBE9BF]">0</span>
                                            
                                        </li> */}
                                       
                                        <li className="relative flex items-center px-3 pt-2 justify-center">
                                             <p className="text-base text-brand">{t.Calc.totalText}</p>
                                            <span className="text-base text-[#299E22] font-semibold pl-[5px]">$ {totalFeeCredMexico}</span>
                                        </li>
                                     </ul>
                                </div>
                                
                            </div>
                            <div className='text-base text-brand font-medium text-center mt-2'>{t.Calc.annAmt} = $ {((totalFeeOtherMexico - totalFeeCredMexico)*12).toFixed(2)}</div>
                            <div className="mt-3 flex items-center justify-between sm:flex-col pr-2">
                                <p className="text-base text-brand font-medium w-[70%]">{t.Calc.note}</p>
                                <Link href="https://app.credlix.com/nuphi/#/signup/exporter/verify" target="_blank" rel="noopener noreferrer" className="text-white py-1 px-3 rounded-lg flex items-center sm:mt-3 bg-gradient-to-r from-[#022B5C] to-[#0363C4] shadow-md transition-all duration-300 ease-in-out hover:from-[#0363C4] hover:to-[#022B5C]">{t.Calc.ctaName}
                                  <span className="mr-[5px] align-middle"><svg xmlns="https://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path d="M12.1717 12.0005L9.34326 9.17203L10.7575 7.75781L15.0001 12.0005L10.7575 16.2431L9.34326 14.8289L12.1717 12.0005Z" fill="rgba(255,255,255,1)"></path></svg></span>
                                </Link>
                            </div>
                        </div>   
                </div>
            </div>
        </section>
            
        }
    </main>
    )
}


export default InterestCalculator;